import managementAxe from '../../services/axios-client/managementServisAxeClient';
import caller from './aiProductsSlice';

const serverError = 'Si è verificato un problema con il server';

export const getConversations = async (page) => {
  caller.getConversationsPending();

  try {
    const response = await managementAxe.get('/ai/product-agent/conversations', {
      params: {
        page,
      },
    });

    if (response.status !== 200) {
      caller.getConversationsRejected(serverError);
      return;
    }
    caller.getConversationsSuccess(response.data);
  } catch (error) {
    caller.getConversationsRejected(serverError);
  }
};

export const resetConversationsState = () => {
  caller.resetConversationsState();
};

export const fetchConversation = async (threadId) => {
  caller.getConversationPending();

  try {
    const response = await managementAxe.get(`/ai/product-agent/conversation/${threadId}`);

    if (response.status !== 200) {
      caller.getConversationRejected(serverError);
      return;
    }
    caller.getConversationSuccess(response.data);
  } catch (error) {
    caller.getConversationRejected(serverError);
  }
};

export const conversationStateReset = () => {
  caller.resetConversationState();
};
